module.exports = __webpack_public_path__ + "img/9788954617451.8c31cf64.jpg";